import { QuotePro, QuoteSimpleStatus } from '@jms/model';

import { defineStatusTag } from '../../shared/define.status.tag';

// Single source of Quote Template status colour, for the board card and the document header alike.
// Approved reads as Public, legacy's name for it: approval is what offers a template on new quotes.
export const quoteTemplateStatusTag = defineStatusTag<QuoteSimpleStatus.Draft | QuoteSimpleStatus.Approved, QuotePro>({
  [QuoteSimpleStatus.Draft]: 'neutral',
  [QuoteSimpleStatus.Approved]: 'brand',
}, { fallback: 'neutral', labels: { [QuoteSimpleStatus.Approved]: 'Public' } });
